<template>
	<div class="app-container mianInfo">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>
			<el-button type="primary" icon="el-icon-plus" class="mb20" @click="handleAdd">新增教学内容</el-button>

			<el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="box_form">
				<el-form-item label="教学内容" prop="title">
					<el-input v-model="queryParams.title" placeholder="教学内容" clearable @keyup.enter.native="handleQuery"
						@change="$forceUpdate()"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
					<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>

			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="编号" align="center" prop="id" width="60" />
				<el-table-column label="模块" align="center" prop="moduleType">
					<template slot-scope="scope">
						{{moduleObj[scope.row.moduleType]}}
					</template>
				</el-table-column>
				<el-table-column label="分类" align="center" prop="teachingTypeName">
					<template slot-scope="scope">
						{{scope.row.teachingTypeName || '--'}}
					</template>
				</el-table-column>
				<el-table-column label="标题" align="center" prop="title" />
				<el-table-column label="发布人员" align="center" prop="createBy" />
				<el-table-column label="发布时间" align="center" prop="createTime" />
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleDtl(scope.row)">详情</el-button>
						<el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />

			<el-dialog :title="dialogTit" :visible.sync="dialogShow" append-to-body>
				<el-form ref="setform" :model="setParams" size="mini" :rules="rules" label-width="120px">
					<el-form-item label="模块:" prop="moduleType">
						<el-select filterable v-model="setParams.moduleType" placeholder="赛事模块" clearable
							@change="$forceUpdate()">
							<el-option v-for="(item, index) in modules" :key="index" :label="item.name"
								:value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item label="标题:" prop="title" style="width: 315px;">
						<el-input v-model="setParams.title" placeholder="输入赛事标题" clearable
							@change="$forceUpdate()"></el-input>
					</el-form-item>
					<el-form-item label="分类:" prop="teachingTypeId" v-if="setParams.moduleType == '1'">
						<el-select filterable v-model="setParams.teachingTypeId" placeholder="赛事分类" clearable
							@change="$forceUpdate()">
							<el-option v-for="(item, index) in types" :key="index" :label="item.teachingTypeName"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item label="内容:" prop="teachingContent"
						v-if="setParams.moduleType != '2' && setParams.moduleType != '3'">
						<editor v-model="setParams.teachingContent" :height="500" />
					</el-form-item>
					<div class="coverUpload" v-if="setParams.moduleType == '2' || setParams.moduleType == '3'">
						<el-form-item label="封面图:" prop="coverUrl" class="small">
							<div :class="{'got': !!setParams.coverUrl}">
								<el-upload :limit="1" :action="action" :headers="headers" :file-list="fileList" @change="$forceUpdate()"
									list-type="picture-card" accept=".jpg, .png, .jpeg" :on-preview="handlePreview"
									:on-success="changeCover" :on-remove="removeCover">
									<i class="el-icon-plus"></i>
									<span class="uploadNote">上传图片</span>
								</el-upload>
							</div>
						</el-form-item>
					</div>
					<el-form-item label="视频文件:" prop="videoFile" ref="upload"
						v-if="setParams.moduleType == '2' || setParams.moduleType == '3'">
						<div style="display: block; height: auto">
							<video style="width: 300px; height: 200px" :src="setParams.videoFile" controls class="video"
								v-if="setParams.videoFile"></video>
							<el-upload class="videoUpload" accept=".mp4" :limit="1" :action="action" :headers="headers"
								:before-upload="beforeUpload" :on-success="selectChangeVideo" :on-remove="removeVideo"
								:on-progress="handleProgerss" :file-list="videoList" @change="$forceUpdate()">
								<el-button size="small" icon="el-icon-upload" type="primary">上传视频 </el-button>
							</el-upload>
							<!-- <el-progress v-if="authProgress > 0 && authProgress < 100" class="uploadProgress" :stroke-width="5" :percentage="authProgress"></el-progress> -->
							<!-- <div style="color: #999999; font-size: 13px"> 说明：视频支持MP4，大小限制在500MB </div> -->
						</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cancel">取 消</el-button>
					<el-button type="primary" @click="submitForm">确认</el-button>
				</div>
			</el-dialog>
			<el-dialog title="教学内容详情" :visible.sync="dialogShowTeach" append-to-body>
				<div style="line-height: 40px">
					<el-row :gutter="24">
						<el-col :span="24">模块：{{ moduleObj[teachDetail.moduleType] }}</el-col>
					</el-row>
					<el-row :gutter="24">
						<el-col :span="24">标题：{{ teachDetail.title }}</el-col>
					</el-row>
					<el-row :gutter="24" v-if="teachDetail.moduleType == '1'">
						<el-col :span="24">分类：{{ teachDetail.teachingTypeName }}</el-col>
					</el-row>
					<el-row :gutter="24" v-if="teachDetail.moduleType == '1'">
						<el-col :span="24">内容：
							<editor v-model="teachDetail.teachingContent" :height="500" aria-readonly="true" />
						</el-col>
						<!-- {{teachDetail.teachingContent}} -->
					</el-row>
					<el-row :gutter="24" v-if="teachDetail.moduleType == '2' || teachDetail.moduleType == '3'">
						<el-col :span="24" style="display: flex;">
							<div>
								封面图：
							</div>
							<div>
								<img :src="teachDetail.coverUrl" alt="" />
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="24" v-if="teachDetail.moduleType == '2' || teachDetail.moduleType == '3'">
						<el-col :span="24" style="display: flex;">
							<div>
								视频文件：
							</div>
							<div>
								<video style="width: 300px; height: 200px" :src="teachDetail.videoFile" controls
									class="video" v-if="teachDetail.videoFile"></video>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	import * as API_Teach from "@/api/sportManage/teach";
	import store from "@/store/index";
	export default {
		name: "userIndex",
		data() {
			return {
				pageName: '教学内容',
				action: process.env.VUE_APP_BASE_API + "/api/file/uploadOss",
				headers: {
					system: 0,
					token: store.state.token,
				},
				queryParams: {
					teachingContent: '',
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false,

				types: [],
				modules: [{
						value: '1',
						name: '赛事教程(图文)'
					},
					{
						value: '2',
						name: '赛事课程(视频)'
					},
					{
						value: '3',
						name: '赛事虚拟教程(视频)'
					},
				],
				moduleObj: {
					'1': '赛事教程(图文)',
					'2': '赛事课程(视频)',
					'3': '赛事虚拟教程(视频)',
				},

				dialogShow: false,
				setParams: {
					moduleType: '1'
				},
				rules: {
					moduleType: [{
						required: true,
						message: "请选择赛事模块",
						trigger: "change"
					}],
					title: [{
						required: true,
						message: "请输入赛事标题",
						trigger: "change"
					}],
					teachingTypeId: [{
						required: true,
						message: "请选择赛事分类",
						trigger: "change"
					}],
					teachingContent: [{
						required: true,
						message: "请输入教学内容",
						trigger: "change"
					}],
					coverUrl: [{
						required: true,
						message: "请上传封面图",
						trigger: "change"
					}],
					videoFile: [{
						required: true,
						message: "请上传视频文件",
						trigger: "change"
					}]
				},
				fileList: [],
				videoList: [],
				dialogTit: '',
				dialogShowTeach: false,
				teachDetail: []
			};
		},
		created() {
			this._getList()
			this._getTypes()
		},
		methods: {
			// 接口-教学列表
			_getList() {
				this.loading = true
				API_Teach.teachList(this.queryParams).then((res) => {
					console.log(res.data);
					this.loading = false;
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			// 接口-教学分类列表
			_getTypes() {
				API_Teach.getTypes().then((res) => {
					console.log(res.data);
					this.types = res.data
				}).catch((err) => {

				});
			},
			//接口-新增教学内容
			_addTeach() {
				API_Teach.addTeach(this.setParams).then((res) => {
					console.log(res);
					this.$message({
						message: '添加成功',
						type: 'success'
					})
					this.refreshList()
				}).catch((err) => {

				});
			},
			//接口-编辑教学内容
			_editTeach() {
				API_Teach.editTeach(this.setParams).then((res) => {
					console.log(res);
					this.$message({
						message: '编辑成功',
						type: 'success'
					})
					this.refreshList()
				}).catch((err) => {

				});
			},
			//接口-删除教学内容
			_delTeach(id) {
				API_Teach.delTeach(id).then((res) => {
					this.$message({
						message: "已删除",
					});
					this._getList()
				});
			},

			handleQuery() {
				this.queryParams.pageNum = 1;
				this._getList();
			},
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this._getList();
			},
			refreshList() {
				this.resetQuery();
				this.dialogShow = false
			},
			// 编辑教学
			handleEdit(row) {
				console.log(row);
				this.dialogShow = true
				this.dialogTit = '编辑教学内容'
				this.clear()
				this.setParams = JSON.parse(JSON.stringify(row));
				this.fileList = [{
					name: '',
					url: row.coverUrl
				}];
				this.videoList = [{
					name: '视频文件',
					url: row.videoFile
				}];
			},
			submitForm() {
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this.clear()
						this.dialogShow = false
						this.setParams.id ? this._editTeach() : this._addTeach()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},

			//新增模板
			handleAdd() {
				this.dialogShow = true;
				this.dialogTit = '新增教学内容'
				this.clear()
				this.setParams = {
					moduleType: '1'
				};
				this.fileList = [];
				this.videoList = [];
			},
			cancel() {
				this.setParams = {}
				this.dialogShow = false
				this.clear()
			},
			clear() {
				this.$nextTick(() => {
					this.$refs['setform'].clearValidate();
				})
			},
			//删除提示
			handleDel(e) {
				this.$confirm(`是否确定删除教学内容"${e.title}"？`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this._delTeach(e.id)
					})
					.catch(() => {});
			},
			// 图片上传
			changeCover(e) {
				this.$set(this.setParams, 'coverUrl', e.data.url)
				this.$forceUpdate();
			},
			removeCover(file) {
				this.setParams.coverUrl = "";
				this.$forceUpdate();
			},
			handlePreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			beforeUpload(e) {
				console.log(e);
			},
			removeVideo() {
				this.setParams.videoFile = '';
				this.videoList = [];
				this.$forceUpdate();
			},
			selectChangeVideo(e) {
				// this.setParams.videoFile = e.data.url;
				this.$set(this.setParams,'videoFile',e.data.url)
				this.videoList[0] = {
					name: e.data.fileName,
					url: e.data.url
				}
				// this.$refs['setform'].clearValidate();
				this.$refs.upload.clearValidate();
				this.$forceUpdate();
			},
			handleProgerss(e) {
				console.log(e);
			},
			handleDtl(row) {
				this.dialogShowTeach = true
				this.teachDetail = row
			},
		},
	};
</script>

<style lang="scss">
	@import "../../../assets/styles/common.scss";
</style>